module.exports = __webpack_public_path__ + "static/img/e3_seal@2x.5f47a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/e3_seal@2x.png
// module id = pH7v
// module chunks = 0